import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { useSelector, useDispatch } from "react-redux";
import { fetchTimeout } from "../components/Common";
import { API_BASE } from "../AppConfig";

import cds_terms from "../assets/cds_terms.pdf";
import lysaght_terms from "../assets/lysaght_terms.pdf";

import Main_ToolBar from "./Main_ToolBar";
import JobRecallPage from "./JobRecallPage";
import NewJob from "./NewJob/NewJob";
import NewsMain from "./NewsMain";
import JobOrdersPage from "./JobOrdersPage";
import { MAIN_PAGE, updateAPP } from "../redux_store/appState";
import { BSL_HelpLysaght } from "../components/BSL_HelpLysaght";

const styles = {
    card: {
        maxWidth: 420,
    },
    media: {
        // ⚠︝ object-fit is not supported by IE 11.
        objectFit: "cover",
    },
    newspaper: {
        padding: 50,
    },
    mainContainer: {
        transition: "all 0.1s ease",
    },
};

function Main(props) {
    const dispatch = useDispatch();

    const page = useSelector((state) => state.app.page);
    const main_page = useSelector((state) => state.app.MAIN_PAGE);
    const job = useSelector((state) => state.job);
    const user = useSelector((state) => state.app.user);
    const help_open = useSelector((state) => state.app.help_open);

    const [updatingLazyLoad, setUpdatingLazyLoad] = React.useState(false);
    const [RecallPageHeight, setRecallPageHeight] = React.useState(0);

    React.useLayoutEffect(() => {
        if (page !== MAIN_PAGE) {
            setUpdatingLazyLoad(false);
            return;
        }
        const handleScroll = (e) => {
            const winScroll = document.body.scrollTop || document.documentElement.scrollTop;

            const height = document.documentElement.scrollHeight - document.documentElement.clientHeight;

            const scrolled = winScroll / height;
            if (main_page.page === "Recall" && page === MAIN_PAGE && scrolled <= 0.95) {
                setUpdatingLazyLoad(false);
                return;
            }
            if (updatingLazyLoad) return;

            if (main_page.page === "Recall" && page === MAIN_PAGE && scrolled >= 0.99 && height > RecallPageHeight) {
                setUpdatingLazyLoad(true);
                setRecallPageHeight(height);

                let lazy_load_increment = 20;
                dispatch(
                    updateAPP("MAIN_PAGE", {
                        ...main_page,
                        NumRecallItems: main_page.NumRecallItems + lazy_load_increment,
                    })
                ).then(() => {
                    setTimeout(setUpdatingLazyLoad(false), 3000);
                });
            }
        };

        window.addEventListener("scroll", handleScroll);

        return () => window.removeEventListener("scroll", handleScroll);
    });

    React.useLayoutEffect(() => {
        setUpdatingLazyLoad(false);
    }, [page, main_page.page]);

    return (
        <div
            className={props.classes.mainContainer}
            style={props.visible ? (help_open ? { marginRight: "400px" } : {}) : { display: "none" }}
        >
            <Main_ToolBar />

            {main_page.page === "Recall" && <JobRecallPage updatingLazyLoad={updatingLazyLoad} />}
            {user?.Role && user.Role >= 90 && <JobOrdersPage visible={main_page.page === "Orders"} />}
            {main_page.page === "New" && <NewJob job={null} mode={main_page.page} />}
            {main_page.page === "Duplicate" && <NewJob job={job} mode={main_page.page} />}
            {main_page.page === "News" && <NewsMain />}
            <div
                style={{
                    padding: "10px 10px",
                    position: "fixed",
                    display: "flex",
                    bottom: "0px",
                    width: "100%",
                    justifyContent: "center",
                    backdropFilter: "blur(10px)",
                    backgroundColor: "rgba(255, 255, 255, 0.3)",
                }}
            >
                <a href="https://cdn.dcs.bluescope.com.au/download/bluescope-privacy-policy" target="_blank">
                    Privacy Policy
                </a>{" "}
                |{" "}
                <a href={window.FIELDERS ? cds_terms : lysaght_terms} target="_blank">
                    Terms of Use
                </a>{" "}
                |{" "}
                <a
                    href={
                        window.FIELDERS
                            ? "https://fielders.com.au/wp-content/uploads/Fielders-terms-conditions.pdf"
                            : window.LYSAGHT
                            ? "https://cdn.dcs.bluescope.com.au/download/lysaght-sales-terms-and-conditions.pdf"
                            : "https://fielders.com.au/wp-content/uploads/Fielders-terms-conditions.pdf"
                    }
                    target="_blank"
                >
                    Terms and Conditions
                </a>{" "}
                |{" "}
                <a
                    href="#"
                    onClick={() => {
                        let api_url = API_BASE() + "IsAlive/";
                        fetchTimeout(api_url, {
                            method: "POST",
                        })
                            .then((response) => response.json())
                            .then((json) => {
                                alert(JSON.stringify(json));
                                console.warn(json);
                            })
                            .catch((e) => {});
                    }}
                >
                    System
                </a>
            </div>

            <BSL_HelpLysaght />
        </div>
    );
}

export default withStyles(styles)(Main);
